(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-klock'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'korge-root-klock'.");
    }
    root['korge-root-klock'] = factory(typeof this['korge-root-klock'] === 'undefined' ? {} : this['korge-root-klock'], this['kotlin-kotlin-stdlib-js-ir']);
  }
}(this, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var log10 = Math.log10;
  var listOf = kotlin_kotlin.$_$.k8;
  var protoOf = kotlin_kotlin.$_$.yc;
  var objectMeta = kotlin_kotlin.$_$.xc;
  var VOID = kotlin_kotlin.$_$.ni;
  var setMetadataFor = kotlin_kotlin.$_$.zc;
  var Unit_getInstance = kotlin_kotlin.$_$.a5;
  var Enum = kotlin_kotlin.$_$.qg;
  var classMeta = kotlin_kotlin.$_$.lb;
  var Long = kotlin_kotlin.$_$.ug;
  var numberToLong = kotlin_kotlin.$_$.vc;
  var toString = kotlin_kotlin.$_$.dd;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var compareTo = kotlin_kotlin.$_$.mb;
  var THROW_CCE = kotlin_kotlin.$_$.ah;
  var getNumberHashCode = kotlin_kotlin.$_$.ub;
  var equals = kotlin_kotlin.$_$.ob;
  var Comparable = kotlin_kotlin.$_$.mg;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var fillArrayVal = kotlin_kotlin.$_$.qb;
  var hashCode = kotlin_kotlin.$_$.xb;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.m;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.h2;
  var toList = kotlin_kotlin.$_$.q9;
  var Companion_getInstance = kotlin_kotlin.$_$.r4;
  var startsWith = kotlin_kotlin.$_$.ff;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.e1;
  var checkIndexOverflow = kotlin_kotlin.$_$.a6;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.h1;
  var joinToString = kotlin_kotlin.$_$.x7;
  var numberToInt = kotlin_kotlin.$_$.uc;
  var abs = kotlin_kotlin.$_$.fd;
  var startsWith_0 = kotlin_kotlin.$_$.ef;
  var getStringHashCode = kotlin_kotlin.$_$.wb;
  var interfaceMeta = kotlin_kotlin.$_$.zb;
  var isNaN_0 = kotlin_kotlin.$_$.ai;
  var DoubleCompanionObject_getInstance = kotlin_kotlin.$_$.j4;
  var round = kotlin_kotlin.$_$.hd;
  var toMap = kotlin_kotlin.$_$.t9;
  var objectCreate = kotlin_kotlin.$_$.wc;
  var to = kotlin_kotlin.$_$.mi;
  var ensureNotNull = kotlin_kotlin.$_$.th;
  var charSequenceGet = kotlin_kotlin.$_$.ib;
  var charSequenceLength = kotlin_kotlin.$_$.jb;
  var padStart = kotlin_kotlin.$_$.ve;
  var KProperty0 = kotlin_kotlin.$_$.zd;
  var getPropertyCallableRef = kotlin_kotlin.$_$.vb;
  var lazy = kotlin_kotlin.$_$.ci;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(DatePart, 'DatePart', classMeta, Enum);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(DateTime, 'DateTime', classMeta, VOID, [Comparable]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(DateTimeTz, 'DateTimeTz', classMeta, VOID, [Comparable]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(DayOfWeek, 'DayOfWeek', classMeta, Enum);
  setMetadataFor(KlockLocale, 'KlockLocale', classMeta);
  setMetadataFor(English, 'English', classMeta, KlockLocale);
  setMetadataFor(Companion_3, 'Companion', objectMeta, English);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(KlockLocaleContext, 'KlockLocaleContext', classMeta);
  setMetadataFor(KlockLocaleGender, 'KlockLocaleGender', classMeta, Enum);
  setMetadataFor(TimedResult, 'TimedResult', classMeta);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(Month, 'Month', classMeta, Enum);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(Options, 'Options', classMeta);
  setMetadataFor(PatternDateFormat, 'PatternDateFormat', classMeta);
  setMetadataFor(PerformanceCounter, 'PerformanceCounter', objectMeta);
  setMetadataFor(TimeProvider, 'TimeProvider', interfaceMeta);
  setMetadataFor(Companion_9, 'Companion', objectMeta, VOID, [TimeProvider]);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor(TimeSpan, 'TimeSpan', classMeta, VOID, [Comparable]);
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor(TimezoneNames, 'TimezoneNames', classMeta);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor(TimezoneOffset, 'TimezoneOffset', classMeta, VOID, [Comparable]);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(MicroStrReader, 'MicroStrReader', classMeta);
  setMetadataFor(KlockInternal, 'KlockInternal', objectMeta);
  //endregion
  function Companion() {
    Companion_instance = this;
    this.fy_1 = Companion_getInstance_0().ky('EEE, dd MMM yyyy HH:mm:ss z');
    this.gy_1 = Companion_getInstance_0().ky("yyyy-MM-dd'T'HH:mm:ssXXX");
    this.hy_1 = Companion_getInstance_0().ky("yyyy-MM-dd'T'HH:mm:ss.SSSZ");
    this.iy_1 = Companion_getInstance_0().ky('yyyy-MM-dd');
    this.jy_1 = listOf([this.fy_1, this.gy_1, this.hy_1, this.iy_1]);
  }
  protoOf(Companion).ky = function (pattern) {
    return new PatternDateFormat(pattern);
  };
  var Companion_instance;
  function Companion_getInstance_0() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function format(_this__u8e3s4, dd) {
    var tmp$ret$0;
    // Inline function 'korlibs.time.minutes' call
    tmp$ret$0 = Companion_getInstance_11().ry(0.0);
    return _this__u8e3s4.sy(DateTime__toOffsetUnadjusted_impl_iorn(dd, tmp$ret$0));
  }
  var DatePart_Year_instance;
  var DatePart_DayOfYear_instance;
  var DatePart_Month_instance;
  var DatePart_Day_instance;
  var DatePart_entriesInitialized;
  function DatePart_initEntries() {
    if (DatePart_entriesInitialized)
      return Unit_getInstance();
    DatePart_entriesInitialized = true;
    DatePart_Year_instance = new DatePart('Year', 0);
    DatePart_DayOfYear_instance = new DatePart('DayOfYear', 1);
    DatePart_Month_instance = new DatePart('Month', 2);
    DatePart_Day_instance = new DatePart('Day', 3);
  }
  function DatePart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function DatePart_Year_getInstance() {
    DatePart_initEntries();
    return DatePart_Year_instance;
  }
  function DatePart_DayOfYear_getInstance() {
    DatePart_initEntries();
    return DatePart_DayOfYear_instance;
  }
  function DatePart_Month_getInstance() {
    DatePart_initEntries();
    return DatePart_Month_instance;
  }
  function DatePart_Day_getInstance() {
    DatePart_initEntries();
    return DatePart_Day_instance;
  }
  function _DateTime___init__impl__ifgty2(unixMillis) {
    return unixMillis;
  }
  function _DateTime___get_unixMillis__impl__ofxkzp($this) {
    return $this;
  }
  function Companion_0() {
    Companion_instance_0 = this;
    this.ty_1 = new Long(1, 0);
    this.uy_1 = _DateTime___init__impl__ifgty2(0.0);
    this.vy_1 = 6.21355968E13;
  }
  protoOf(Companion_0).wy = function (unix) {
    return _DateTime___init__impl__ifgty2(unix);
  };
  protoOf(Companion_0).xy = function (unix) {
    return this.wy(unix.re());
  };
  protoOf(Companion_0).yy = function () {
    return _DateTime___init__impl__ifgty2(KlockInternal_getInstance().zy());
  };
  protoOf(Companion_0).az = function () {
    return numberToLong(KlockInternal_getInstance().zy());
  };
  protoOf(Companion_0).bz = function (year, month, day) {
    return (((_Year___get_daysSinceOne__impl__cf4kem(_Year___init__impl__2jvef0(year)) + Companion_getInstance_7().hz(month).nz(year) | 0) + day | 0) - 1 | 0) * get_MILLIS_PER_DAY() - 6.21355968E13;
  };
  protoOf(Companion_0).oz = function (millis, part) {
    var totalDays = toInt2(millis / get_MILLIS_PER_DAY());
    var year = Companion_getInstance_14().yz(totalDays);
    if (part.equals(DatePart_Year_getInstance()))
      return _Year___get_year__impl__hjar94(year);
    var isLeap = _Year___get_isLeap__impl__kmyeoz(year);
    var startYearDays = _Year___get_daysSinceOne__impl__cf4kem(year);
    var dayOfYear = 1 + umod(totalDays - startYearDays | 0, _Year___get_days__impl__xyqg2q(year)) | 0;
    if (part.equals(DatePart_DayOfYear_getInstance()))
      return dayOfYear;
    var tmp0_elvis_lhs = Companion_getInstance_7().zz(dayOfYear, isLeap);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = 'Invalid dayOfYear=' + dayOfYear + ', isLeap=' + isLeap;
      throw IllegalStateException_init_$Create$(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var month = tmp;
    if (part.equals(DatePart_Month_getInstance()))
      return month.kz_1;
    var dayOfMonth = dayOfYear - month.a10(isLeap) | 0;
    if (part.equals(DatePart_Day_getInstance()))
      return dayOfMonth;
    // Inline function 'kotlin.error' call
    throw IllegalStateException_init_$Create$('Invalid DATE_PART');
  };
  var Companion_instance_0;
  function Companion_getInstance_1() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function _DateTime___get_yearOneMillis__impl__jjnslg($this) {
    Companion_getInstance_1();
    return 6.21355968E13 + _DateTime___get_unixMillis__impl__ofxkzp($this);
  }
  function _DateTime___get_unixMillisDouble__impl__3dzlsc($this) {
    return _DateTime___get_unixMillis__impl__ofxkzp($this);
  }
  function _DateTime___get_unixMillisLong__impl__sdx9bd($this) {
    return numberToLong(_DateTime___get_unixMillisDouble__impl__3dzlsc($this));
  }
  function _DateTime___get_year__impl__mczyhi($this) {
    return _Year___init__impl__2jvef0(_DateTime___get_yearInt__impl__876eh3($this));
  }
  function _DateTime___get_yearInt__impl__876eh3($this) {
    return Companion_getInstance_1().oz(_DateTime___get_yearOneMillis__impl__jjnslg($this), DatePart_Year_getInstance());
  }
  function _DateTime___get_month__impl__4rr4id($this) {
    return Companion_getInstance_7().k(_DateTime___get_month1__impl__hf8ase($this));
  }
  function _DateTime___get_month1__impl__hf8ase($this) {
    return Companion_getInstance_1().oz(_DateTime___get_yearOneMillis__impl__jjnslg($this), DatePart_Month_getInstance());
  }
  function _DateTime___get_dayOfMonth__impl__z5062($this) {
    return Companion_getInstance_1().oz(_DateTime___get_yearOneMillis__impl__jjnslg($this), DatePart_Day_getInstance());
  }
  function _DateTime___get_dayOfWeek__impl__o3da04($this) {
    return Companion_getInstance_3().k(_DateTime___get_dayOfWeekInt__impl__yrgob9($this));
  }
  function _DateTime___get_dayOfWeekInt__impl__yrgob9($this) {
    return toIntMod(_DateTime___get_yearOneMillis__impl__jjnslg($this) / get_MILLIS_PER_DAY() + 1, 7);
  }
  function _DateTime___get_hours__impl__gihczo($this) {
    return toIntMod(_DateTime___get_yearOneMillis__impl__jjnslg($this) / get_MILLIS_PER_HOUR(), 24);
  }
  function _DateTime___get_minutes__impl__ua9590($this) {
    return toIntMod(_DateTime___get_yearOneMillis__impl__jjnslg($this) / get_MILLIS_PER_MINUTE(), 60);
  }
  function _DateTime___get_seconds__impl__145pqk($this) {
    return toIntMod(_DateTime___get_yearOneMillis__impl__jjnslg($this) / get_MILLIS_PER_SECOND(), 60);
  }
  function _DateTime___get_milliseconds__impl__xmznxd($this) {
    return toIntMod(_DateTime___get_yearOneMillis__impl__jjnslg($this), 1000);
  }
  function DateTime__toOffsetUnadjusted_impl_iorn($this, offset) {
    return DateTime__toOffsetUnadjusted_impl_iorn_0($this, get_offset(offset));
  }
  function DateTime__toOffsetUnadjusted_impl_iorn_0($this, offset) {
    return Companion_getInstance_2().f10($this, offset);
  }
  function DateTime__plus_impl_5iyako($this, delta) {
    return DateTime__add_impl_fzlt95($this, 0, _TimeSpan___get_milliseconds__impl__pb0we5(delta));
  }
  function DateTime__minus_impl_10njw8($this, delta) {
    return DateTime__plus_impl_5iyako($this, TimeSpan__unaryMinus_impl_24dqtx(delta));
  }
  function DateTime__minus_impl_10njw8_0($this, other) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp0_get_milliseconds_saqqmp = _DateTime___get_unixMillisDouble__impl__3dzlsc($this) - _DateTime___get_unixMillisDouble__impl__3dzlsc(other);
    return Companion_getInstance_11().g10(tmp0_get_milliseconds_saqqmp);
  }
  function DateTime__compareTo_impl_geo3bs($this, other) {
    return compareTo(_DateTime___get_unixMillis__impl__ofxkzp($this), _DateTime___get_unixMillis__impl__ofxkzp(other));
  }
  function DateTime__compareTo_impl_geo3bs_0($this, other) {
    var tmp = $this.h10_1;
    return DateTime__compareTo_impl_geo3bs(tmp, other instanceof DateTime ? other.h10_1 : THROW_CCE());
  }
  function DateTime__add_impl_fzlt95($this, deltaMonths, deltaMilliseconds) {
    var tmp;
    if (deltaMonths === 0 ? deltaMilliseconds === 0.0 : false) {
      tmp = $this;
    } else if (deltaMonths === 0) {
      tmp = _DateTime___init__impl__ifgty2(_DateTime___get_unixMillis__impl__ofxkzp($this) + deltaMilliseconds);
    } else {
      var year = _DateTime___get_year__impl__mczyhi($this);
      var month = _DateTime___get_month__impl__4rr4id($this).kz_1;
      var day = _DateTime___get_dayOfMonth__impl__z5062($this);
      var i = (month - 1 | 0) + deltaMonths | 0;
      if (i >= 0) {
        Companion_getInstance_7();
        month = (i % 12 | 0) + 1 | 0;
        var tmp_0 = year;
        Companion_getInstance_7();
        year = Year__plus_impl_l5v1ey(tmp_0, i / 12 | 0);
      } else {
        Companion_getInstance_7();
        var tmp_1 = i + 1 | 0;
        Companion_getInstance_7();
        month = 12 + (tmp_1 % 12 | 0) | 0;
        var tmp_2 = year;
        Companion_getInstance_7();
        var tmp_3 = i - (12 - 1 | 0) | 0;
        Companion_getInstance_7();
        year = Year__plus_impl_l5v1ey(tmp_2, tmp_3 / 12 | 0);
      }
      var days = Companion_getInstance_7().hz(month).i10(year);
      if (day > days)
        day = days;
      tmp = _DateTime___init__impl__ifgty2(Companion_getInstance_1().bz(_Year___get_year__impl__hjar94(year), month, day) + _DateTime___get_yearOneMillis__impl__jjnslg($this) % get_MILLIS_PER_DAY() + deltaMilliseconds);
    }
    return tmp;
  }
  function DateTime__format_impl_6el5l1($this, format_0) {
    return format(format_0, $this);
  }
  function DateTime__toString_impl_cnueje($this) {
    return 'DateTime(' + toString(_DateTime___get_unixMillisLong__impl__sdx9bd($this)) + ')';
  }
  function DateTime__hashCode_impl_yf0bc9($this) {
    return getNumberHashCode($this);
  }
  function DateTime__equals_impl_qd7s8j($this, other) {
    if (!(other instanceof DateTime))
      return false;
    var tmp0_other_with_cast = other instanceof DateTime ? other.h10_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function DateTime(unixMillis) {
    Companion_getInstance_1();
    this.h10_1 = unixMillis;
  }
  protoOf(DateTime).j10 = function (other) {
    return DateTime__compareTo_impl_geo3bs(this.h10_1, other);
  };
  protoOf(DateTime).t8 = function (other) {
    return DateTime__compareTo_impl_geo3bs_0(this, other);
  };
  protoOf(DateTime).toString = function () {
    return DateTime__toString_impl_cnueje(this.h10_1);
  };
  protoOf(DateTime).hashCode = function () {
    return DateTime__hashCode_impl_yf0bc9(this.h10_1);
  };
  protoOf(DateTime).equals = function (other) {
    return DateTime__equals_impl_qd7s8j(this.h10_1, other);
  };
  function Companion_1() {
    Companion_instance_1 = this;
    this.e10_1 = new Long(1, 0);
  }
  protoOf(Companion_1).f10 = function (local, offset) {
    return new DateTimeTz(local, offset);
  };
  var Companion_instance_1;
  function Companion_getInstance_2() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function DateTimeTz(adjusted, offset) {
    Companion_getInstance_2();
    this.k10_1 = adjusted;
    this.l10_1 = offset;
  }
  protoOf(DateTimeTz).m10 = function () {
    return this.k10_1;
  };
  protoOf(DateTimeTz).n10 = function () {
    return DateTime__minus_impl_10njw8(this.k10_1, _TimezoneOffset___get_time__impl__u2t42f(this.l10_1));
  };
  protoOf(DateTimeTz).hashCode = function () {
    return DateTime__hashCode_impl_yf0bc9(this.m10()) + _TimezoneOffset___get_totalMinutesInt__impl__9h3gzq(this.l10_1) | 0;
  };
  protoOf(DateTimeTz).equals = function (other) {
    var tmp;
    if (other instanceof DateTimeTz) {
      tmp = _DateTime___get_unixMillisDouble__impl__3dzlsc(this.n10()) === _DateTime___get_unixMillisDouble__impl__3dzlsc(other.n10());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DateTimeTz).o10 = function (other) {
    return compareTo(_DateTime___get_unixMillis__impl__ofxkzp(this.n10()), _DateTime___get_unixMillis__impl__ofxkzp(other.n10()));
  };
  protoOf(DateTimeTz).t8 = function (other) {
    return this.o10(other instanceof DateTimeTz ? other : THROW_CCE());
  };
  protoOf(DateTimeTz).toString = function () {
    return 'DateTimeTz(' + new DateTime(this.k10_1) + ', ' + new TimezoneOffset(this.l10_1) + ')';
  };
  var DayOfWeek_Sunday_instance;
  var DayOfWeek_Monday_instance;
  var DayOfWeek_Tuesday_instance;
  var DayOfWeek_Wednesday_instance;
  var DayOfWeek_Thursday_instance;
  var DayOfWeek_Friday_instance;
  var DayOfWeek_Saturday_instance;
  function Companion_2() {
    Companion_instance_2 = this;
    this.b10_1 = new Long(1, 0);
    this.c10_1 = 7;
    this.d10_1 = values();
  }
  protoOf(Companion_2).k = function (index0) {
    return this.d10_1[umod(index0, 7)];
  };
  var Companion_instance_2;
  function Companion_getInstance_3() {
    DayOfWeek_initEntries();
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function values() {
    return [DayOfWeek_Sunday_getInstance(), DayOfWeek_Monday_getInstance(), DayOfWeek_Tuesday_getInstance(), DayOfWeek_Wednesday_getInstance(), DayOfWeek_Thursday_getInstance(), DayOfWeek_Friday_getInstance(), DayOfWeek_Saturday_getInstance()];
  }
  var DayOfWeek_entriesInitialized;
  function DayOfWeek_initEntries() {
    if (DayOfWeek_entriesInitialized)
      return Unit_getInstance();
    DayOfWeek_entriesInitialized = true;
    DayOfWeek_Sunday_instance = new DayOfWeek('Sunday', 0, 0);
    DayOfWeek_Monday_instance = new DayOfWeek('Monday', 1, 1);
    DayOfWeek_Tuesday_instance = new DayOfWeek('Tuesday', 2, 2);
    DayOfWeek_Wednesday_instance = new DayOfWeek('Wednesday', 3, 3);
    DayOfWeek_Thursday_instance = new DayOfWeek('Thursday', 4, 4);
    DayOfWeek_Friday_instance = new DayOfWeek('Friday', 5, 5);
    DayOfWeek_Saturday_instance = new DayOfWeek('Saturday', 6, 6);
    Companion_getInstance_3();
  }
  function DayOfWeek(name, ordinal, index0) {
    Enum.call(this, name, ordinal);
    this.r10_1 = index0;
  }
  protoOf(DayOfWeek).s10 = function (locale) {
    return locale.t10().k(this.r10_1);
  };
  protoOf(DayOfWeek).u10 = function (locale) {
    return locale.v10().k(this.r10_1);
  };
  function DayOfWeek_Sunday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Sunday_instance;
  }
  function DayOfWeek_Monday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Monday_instance;
  }
  function DayOfWeek_Tuesday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Tuesday_instance;
  }
  function DayOfWeek_Wednesday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Wednesday_instance;
  }
  function DayOfWeek_Thursday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Thursday_instance;
  }
  function DayOfWeek_Friday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Friday_instance;
  }
  function DayOfWeek_Saturday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Saturday_instance;
  }
  function _Frequency___init__impl__upasnx(hertz) {
    return hertz;
  }
  function _Frequency___get_hertz__impl__9m7k6x($this) {
    return $this;
  }
  function toFrequency(_this__u8e3s4) {
    return get_timesPerSecond(_this__u8e3s4);
  }
  function get_timesPerSecond(_this__u8e3s4) {
    return _Frequency___init__impl__upasnx(1.0 / _TimeSpan___get_seconds__impl__cx2k1c(_this__u8e3s4));
  }
  var KlockLocale_default;
  function Companion_3() {
    Companion_instance_3 = this;
    English.call(this);
  }
  var Companion_instance_3;
  function Companion_getInstance_4() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function Companion_4() {
    Companion_instance_4 = this;
  }
  protoOf(Companion_4).b11 = function () {
    var tmp0_elvis_lhs = KlockLocale_default;
    return tmp0_elvis_lhs == null ? Companion_getInstance_4() : tmp0_elvis_lhs;
  };
  var Companion_instance_4;
  function Companion_getInstance_5() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function English() {
    Companion_getInstance_4();
    KlockLocale.call(this);
  }
  protoOf(English).t10 = function () {
    return listOf(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);
  };
  protoOf(English).w10 = function () {
    return listOf(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']);
  };
  function KlockLocale() {
    Companion_getInstance_5();
  }
  protoOf(KlockLocale).v10 = function () {
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.t10();
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$0;
      // Inline function 'korlibs.time.KlockLocale.<get-daysOfWeekShort>.<anonymous>' call
      tmp$ret$0 = substr(item, 0, 3);
      tmp0_mapTo.b(tmp$ret$0);
    }
    return tmp0_mapTo;
  };
  protoOf(KlockLocale).x10 = function () {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(32), null);
    while (tmp < 32) {
      var tmp_1 = tmp;
      var tmp_2;
      if (11 <= tmp_1 ? tmp_1 <= 13 : false) {
        tmp_2 = '' + tmp_1 + 'th';
      } else {
        switch (tmp_1 % 10 | 0) {
          case 1:
            tmp_2 = '' + tmp_1 + 'st';
            break;
          case 2:
            tmp_2 = '' + tmp_1 + 'nd';
            break;
          case 3:
            tmp_2 = '' + tmp_1 + 'rd';
            break;
          default:
            tmp_2 = '' + tmp_1 + 'th';
            break;
        }
      }
      tmp_0[tmp_1] = tmp_2;
      tmp = tmp + 1 | 0;
    }
    return tmp_0;
  };
  protoOf(KlockLocale).y10 = function (day, context) {
    return this.x10()[day];
  };
  protoOf(KlockLocale).z10 = function (day, context, $super) {
    context = context === VOID ? Companion_getInstance_6().c11_1 : context;
    return $super === VOID ? this.y10(day, context) : $super.y10.call(this, day, context);
  };
  protoOf(KlockLocale).a11 = function () {
    return listOf(['am', 'pm']);
  };
  function Companion_5() {
    Companion_instance_5 = this;
    this.c11_1 = new KlockLocaleContext();
  }
  var Companion_instance_5;
  function Companion_getInstance_6() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function KlockLocaleContext(gender) {
    Companion_getInstance_6();
    gender = gender === VOID ? KlockLocaleGender_Neuter_getInstance() : gender;
    this.d11_1 = gender;
  }
  protoOf(KlockLocaleContext).toString = function () {
    return 'KlockLocaleContext(gender=' + this.d11_1 + ')';
  };
  protoOf(KlockLocaleContext).hashCode = function () {
    return this.d11_1.hashCode();
  };
  protoOf(KlockLocaleContext).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KlockLocaleContext))
      return false;
    var tmp0_other_with_cast = other instanceof KlockLocaleContext ? other : THROW_CCE();
    if (!this.d11_1.equals(tmp0_other_with_cast.d11_1))
      return false;
    return true;
  };
  var KlockLocaleGender_Neuter_instance;
  var KlockLocaleGender_Masculine_instance;
  var KlockLocaleGender_entriesInitialized;
  function KlockLocaleGender_initEntries() {
    if (KlockLocaleGender_entriesInitialized)
      return Unit_getInstance();
    KlockLocaleGender_entriesInitialized = true;
    KlockLocaleGender_Neuter_instance = new KlockLocaleGender('Neuter', 0);
    KlockLocaleGender_Masculine_instance = new KlockLocaleGender('Masculine', 1);
  }
  function KlockLocaleGender(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function KlockLocaleGender_Neuter_getInstance() {
    KlockLocaleGender_initEntries();
    return KlockLocaleGender_Neuter_instance;
  }
  function TimedResult(result, time) {
    this.e11_1 = result;
    this.f11_1 = time;
  }
  protoOf(TimedResult).e4 = function () {
    return this.e11_1;
  };
  protoOf(TimedResult).g11 = function () {
    return this.f11_1;
  };
  protoOf(TimedResult).toString = function () {
    return 'TimedResult(result=' + this.e11_1 + ', time=' + new TimeSpan(this.f11_1) + ')';
  };
  protoOf(TimedResult).hashCode = function () {
    var result = this.e11_1 == null ? 0 : hashCode(this.e11_1);
    result = imul(result, 31) + TimeSpan__hashCode_impl_izs3k5(this.f11_1) | 0;
    return result;
  };
  protoOf(TimedResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimedResult))
      return false;
    var tmp0_other_with_cast = other instanceof TimedResult ? other : THROW_CCE();
    if (!equals(this.e11_1, tmp0_other_with_cast.e11_1))
      return false;
    if (!equals(this.f11_1, tmp0_other_with_cast.f11_1))
      return false;
    return true;
  };
  function YEAR_DAYS($this, isLeap) {
    return isLeap ? $this.fz_1 : $this.gz_1;
  }
  function generateDaysToStart($this, leap) {
    var total = 0;
    var tmp = 0;
    var tmp_0 = new Int32Array(13);
    while (tmp < 13) {
      var tmp_1 = tmp;
      total = total + (tmp_1 === 0 ? 0 : Companion_getInstance_7().ez_1[tmp_1 - 1 | 0].h11(leap)) | 0;
      tmp_0[tmp_1] = total;
      tmp = tmp + 1 | 0;
    }
    return tmp_0;
  }
  var Month_January_instance;
  var Month_February_instance;
  var Month_March_instance;
  var Month_April_instance;
  var Month_May_instance;
  var Month_June_instance;
  var Month_July_instance;
  var Month_August_instance;
  var Month_September_instance;
  var Month_October_instance;
  var Month_November_instance;
  var Month_December_instance;
  function Companion_6() {
    Companion_instance_6 = this;
    this.cz_1 = new Long(1, 0);
    this.dz_1 = 12;
    this.ez_1 = values_0();
    this.fz_1 = generateDaysToStart(this, true);
    this.gz_1 = generateDaysToStart(this, false);
  }
  protoOf(Companion_6).hz = function (index1) {
    return this.i11(index1);
  };
  protoOf(Companion_6).k = function (index1) {
    return this.i11(index1);
  };
  protoOf(Companion_6).i11 = function (index1) {
    return this.ez_1[umod(index1 - 1 | 0, 12)];
  };
  protoOf(Companion_6).zz = function (dayOfYear, leap) {
    var days = YEAR_DAYS(this, leap);
    var day0 = dayOfYear - 1 | 0;
    var guess = day0 / 32 | 0;
    var tmp;
    if (0 <= guess ? guess <= 11 : false) {
      var containsLower = days[guess];
      tmp = day0 < days[guess + 1 | 0] ? containsLower <= day0 : false;
    } else {
      tmp = false;
    }
    if (tmp)
      return Companion_getInstance_7().k(guess + 1 | 0);
    var tmp_0;
    if (0 <= guess ? guess <= 10 : false) {
      var containsLower_0 = days[guess + 1 | 0];
      tmp_0 = day0 < days[guess + 2 | 0] ? containsLower_0 <= day0 : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0)
      return Companion_getInstance_7().k(guess + 2 | 0);
    return null;
  };
  var Companion_instance_6;
  function Companion_getInstance_7() {
    Month_initEntries();
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function values_0() {
    return [Month_January_getInstance(), Month_February_getInstance(), Month_March_getInstance(), Month_April_getInstance(), Month_May_getInstance(), Month_June_getInstance(), Month_July_getInstance(), Month_August_getInstance(), Month_September_getInstance(), Month_October_getInstance(), Month_November_getInstance(), Month_December_getInstance()];
  }
  var Month_entriesInitialized;
  function Month_initEntries() {
    if (Month_entriesInitialized)
      return Unit_getInstance();
    Month_entriesInitialized = true;
    Month_January_instance = new Month('January', 0, 1, 31);
    Month_February_instance = new Month('February', 1, 2, 28, 29);
    Month_March_instance = new Month('March', 2, 3, 31);
    Month_April_instance = new Month('April', 3, 4, 30);
    Month_May_instance = new Month('May', 4, 5, 31);
    Month_June_instance = new Month('June', 5, 6, 30);
    Month_July_instance = new Month('July', 6, 7, 31);
    Month_August_instance = new Month('August', 7, 8, 31);
    Month_September_instance = new Month('September', 8, 9, 30);
    Month_October_instance = new Month('October', 9, 10, 31);
    Month_November_instance = new Month('November', 10, 11, 30);
    Month_December_instance = new Month('December', 11, 12, 31);
    Companion_getInstance_7();
  }
  function Month(name, ordinal, index1, daysCommon, daysLeap) {
    daysLeap = daysLeap === VOID ? daysCommon : daysLeap;
    Enum.call(this, name, ordinal);
    this.kz_1 = index1;
    this.lz_1 = daysCommon;
    this.mz_1 = daysLeap;
  }
  protoOf(Month).j11 = function () {
    return this.kz_1 - 1 | 0;
  };
  protoOf(Month).h11 = function (leap) {
    return leap ? this.mz_1 : this.lz_1;
  };
  protoOf(Month).i10 = function (year) {
    return this.h11(_Year___get_isLeap__impl__kmyeoz(year));
  };
  protoOf(Month).a10 = function (leap) {
    return YEAR_DAYS(Companion_getInstance_7(), leap)[this.j11()];
  };
  protoOf(Month).nz = function (year) {
    return this.a10(_Year___get_isLeap__impl__kmyeoz(_Year___init__impl__2jvef0(year)));
  };
  protoOf(Month).s10 = function (locale) {
    return locale.w10().k(this.j11());
  };
  function Month_January_getInstance() {
    Month_initEntries();
    return Month_January_instance;
  }
  function Month_February_getInstance() {
    Month_initEntries();
    return Month_February_instance;
  }
  function Month_March_getInstance() {
    Month_initEntries();
    return Month_March_instance;
  }
  function Month_April_getInstance() {
    Month_initEntries();
    return Month_April_instance;
  }
  function Month_May_getInstance() {
    Month_initEntries();
    return Month_May_instance;
  }
  function Month_June_getInstance() {
    Month_initEntries();
    return Month_June_instance;
  }
  function Month_July_getInstance() {
    Month_initEntries();
    return Month_July_instance;
  }
  function Month_August_getInstance() {
    Month_initEntries();
    return Month_August_instance;
  }
  function Month_September_getInstance() {
    Month_initEntries();
    return Month_September_instance;
  }
  function Month_October_getInstance() {
    Month_initEntries();
    return Month_October_instance;
  }
  function Month_November_getInstance() {
    Month_initEntries();
    return Month_November_instance;
  }
  function Month_December_getInstance() {
    Month_initEntries();
    return Month_December_instance;
  }
  function Companion_7() {
    Companion_instance_7 = this;
    this.k11_1 = new Long(1, 0);
    this.l11_1 = new Options(false);
    this.m11_1 = new Options(true);
  }
  var Companion_instance_7;
  function Companion_getInstance_8() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function Companion_8() {
    Companion_instance_8 = this;
    this.n11_1 = new Long(1, 0);
  }
  var Companion_instance_8;
  function Companion_getInstance_9() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function Options(optionalSupport) {
    Companion_getInstance_8();
    optionalSupport = optionalSupport === VOID ? false : optionalSupport;
    this.o11_1 = optionalSupport;
  }
  protoOf(Options).toString = function () {
    return 'Options(optionalSupport=' + this.o11_1 + ')';
  };
  protoOf(Options).hashCode = function () {
    return this.o11_1 | 0;
  };
  protoOf(Options).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Options))
      return false;
    var tmp0_other_with_cast = other instanceof Options ? other : THROW_CCE();
    if (!(this.o11_1 === tmp0_other_with_cast.o11_1))
      return false;
    return true;
  };
  function PatternDateFormat(format, locale, tzNames, options) {
    Companion_getInstance_9();
    locale = locale === VOID ? null : locale;
    tzNames = tzNames === VOID ? Companion_getInstance_12().q11_1 : tzNames;
    options = options === VOID ? Companion_getInstance_8().l11_1 : options;
    this.r11_1 = format;
    this.s11_1 = locale;
    this.t11_1 = tzNames;
    this.u11_1 = options;
    this.v11_1 = LinkedHashMap_init_$Create$();
    this.w11_1 = LinkedHashMap_init_$Create$();
    var tmp = this;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var tmp0_also = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.time.PatternDateFormat.chunks.<anonymous>' call
    var s = new MicroStrReader(this.r11_1);
    $l$loop_1: while (s.c12()) {
      if (s.f12() === _Char___init__impl__6a9atx(39)) {
        // Inline function 'korlibs.time.internal.MicroStrReader.readChunk' call
        var start = s.b12_1;
        // Inline function 'korlibs.time.PatternDateFormat.chunks.<anonymous>.<anonymous>' call
        s.d12(_Char___init__impl__6a9atx(39));
        while (s.c12() ? !(s.e12() === _Char___init__impl__6a9atx(39)) : false)
        ;
        var end = s.b12_1;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var escapedChunk = s.a12_1.substring(start, end);
        tmp0_also.b(escapedChunk);
        continue $l$loop_1;
      }
      if (this.u11_1.o11_1) {
        var offset = tmp0_also.j();
        if (s.d12(_Char___init__impl__6a9atx(91))) {
          increment(this.v11_1, offset);
          continue $l$loop_1;
        }
        if (s.d12(_Char___init__impl__6a9atx(93))) {
          increment(this.w11_1, offset - 1 | 0);
          continue $l$loop_1;
        }
      }
      var tmp0_elvis_lhs = s.g12('do');
      tmp0_also.b(tmp0_elvis_lhs == null ? readRepeatedChar(s) : tmp0_elvis_lhs);
    }
    tmp.x11_1 = toList(tmp0_also);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.x11_1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$5;
      // Inline function 'korlibs.time.PatternDateFormat.regexChunks.<anonymous>' call
      switch (item) {
        case 'E':
        case 'EE':
        case 'EEE':
        case 'EEEE':
        case 'EEEEE':
        case 'EEEEEE':
          tmp$ret$5 = '(\\w+)';
          break;
        case 'z':
        case 'zzz':
          tmp$ret$5 = '([\\w\\s\\-\\+:]+)';
          break;
        case 'do':
          tmp$ret$5 = '(\\d{1,2}\\w+)';
          break;
        case 'd':
          tmp$ret$5 = '(\\d{1,2})';
          break;
        case 'dd':
          tmp$ret$5 = '(\\d{2})';
          break;
        case 'M':
          tmp$ret$5 = '(\\d{1,5})';
          break;
        case 'MM':
          tmp$ret$5 = '(\\d{2})';
          break;
        case 'MMM':
        case 'MMMM':
        case 'MMMMM':
          tmp$ret$5 = '(\\w+)';
          break;
        case 'y':
          tmp$ret$5 = '(\\d{1,5})';
          break;
        case 'yy':
          tmp$ret$5 = '(\\d{2})';
          break;
        case 'yyy':
          tmp$ret$5 = '(\\d{3})';
          break;
        case 'yyyy':
          tmp$ret$5 = '(\\d{4})';
          break;
        case 'YYYY':
          tmp$ret$5 = '(\\d{4})';
          break;
        case 'H':
        case 'k':
          tmp$ret$5 = '(\\d{1,2})';
          break;
        case 'HH':
        case 'kk':
          tmp$ret$5 = '(\\d{2})';
          break;
        case 'h':
        case 'K':
          tmp$ret$5 = '(\\d{1,2})';
          break;
        case 'hh':
        case 'KK':
          tmp$ret$5 = '(\\d{2})';
          break;
        case 'm':
          tmp$ret$5 = '(\\d{1,2})';
          break;
        case 'mm':
          tmp$ret$5 = '(\\d{2})';
          break;
        case 's':
          tmp$ret$5 = '(\\d{1,2})';
          break;
        case 'ss':
          tmp$ret$5 = '(\\d{2})';
          break;
        case 'S':
          tmp$ret$5 = '(\\d{1,9})';
          break;
        case 'SS':
          tmp$ret$5 = '(\\d{2})';
          break;
        case 'SSS':
          tmp$ret$5 = '(\\d{3})';
          break;
        case 'SSSS':
          tmp$ret$5 = '(\\d{4})';
          break;
        case 'SSSSS':
          tmp$ret$5 = '(\\d{5})';
          break;
        case 'SSSSSS':
          tmp$ret$5 = '(\\d{6})';
          break;
        case 'SSSSSSS':
          tmp$ret$5 = '(\\d{7})';
          break;
        case 'SSSSSSSS':
          tmp$ret$5 = '(\\d{8})';
          break;
        case 'SSSSSSSSS':
          tmp$ret$5 = '(\\d{9})';
          break;
        case 'X':
        case 'XX':
        case 'XXX':
        case 'x':
        case 'xx':
        case 'xxx':
        case 'Z':
          tmp$ret$5 = '([\\w:\\+\\-]+)';
          break;
        case 'a':
          tmp$ret$5 = '(\\w+)';
          break;
        case ' ':
          tmp$ret$5 = '(\\s+)';
          break;
        default:
          tmp$ret$5 = startsWith(item, _Char___init__impl__6a9atx(39)) ? '(' + Companion_getInstance().jg(substr(item, 1, item.length - 2 | 0)) + ')' : '(' + Companion_getInstance().jg(item) + ')';
          break;
      }
      tmp0_mapTo.b(tmp$ret$5);
    }
    tmp_0.y11_1 = tmp0_mapTo;
    this.z11_1 = Regex_init_$Create$('^' + this.h12() + '$');
  }
  protoOf(PatternDateFormat).i12 = function () {
    var tmp0_elvis_lhs = this.s11_1;
    return tmp0_elvis_lhs == null ? Companion_getInstance_5().b11() : tmp0_elvis_lhs;
  };
  protoOf(PatternDateFormat).h12 = function () {
    // Inline function 'kotlin.collections.mapIndexed' call
    var tmp0_mapIndexed = this.y11_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var tmp0_mapIndexedTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_mapIndexed, 10));
    var index = 0;
    var tmp0_iterator = tmp0_mapIndexed.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$6;
      // Inline function 'korlibs.time.PatternDateFormat.matchingRegexString.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp1_anonymous = checkIndexOverflow(tmp1);
      var tmp;
      if (this.u11_1.o11_1) {
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp0_elvis_lhs = this.v11_1.c2(tmp1_anonymous);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'korlibs.time.PatternDateFormat.matchingRegexString.<anonymous>.<anonymous>' call
          tmp_0 = 0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var opens = tmp_0;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp0_elvis_lhs_0 = this.w11_1.c2(tmp1_anonymous);
        var tmp_1;
        if (tmp0_elvis_lhs_0 == null) {
          // Inline function 'korlibs.time.PatternDateFormat.matchingRegexString.<anonymous>.<anonymous>' call
          tmp_1 = 0;
        } else {
          tmp_1 = tmp0_elvis_lhs_0;
        }
        var closes = tmp_1;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var tmp0_apply = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.time.PatternDateFormat.matchingRegexString.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.repeat' call
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < opens)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.time.PatternDateFormat.matchingRegexString.<anonymous>.<anonymous>.<anonymous>' call
            tmp0_apply.p8('(?:');
          }
           while (inductionVariable < opens);
        tmp0_apply.p8(item);
        // Inline function 'kotlin.repeat' call
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < closes)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.time.PatternDateFormat.matchingRegexString.<anonymous>.<anonymous>.<anonymous>' call
            tmp0_apply.p8(')?');
          }
           while (inductionVariable_0 < closes);
        tmp = tmp0_apply.toString();
      } else {
        tmp = item;
      }
      tmp$ret$6 = tmp;
      tmp0_mapIndexedTo.b(tmp$ret$6);
    }
    return joinToString(tmp0_mapIndexedTo, '');
  };
  protoOf(PatternDateFormat).sy = function (dd) {
    var utc = dd.m10();
    var out = '';
    var tmp0_iterator = this.x11_1.g();
    while (tmp0_iterator.h()) {
      var name = tmp0_iterator.i();
      var nlen = name.length;
      var tmp = out;
      var tmp_0;
      switch (name) {
        case 'E':
        case 'EE':
        case 'EEE':
          tmp_0 = Companion_getInstance_3().k(_DateTime___get_dayOfWeek__impl__o3da04(utc).r10_1).u10(this.i12());
          break;
        case 'EEEE':
        case 'EEEEE':
        case 'EEEEEE':
          tmp_0 = Companion_getInstance_3().k(_DateTime___get_dayOfWeek__impl__o3da04(utc).r10_1).s10(this.i12());
          break;
        case 'z':
        case 'zzz':
          tmp_0 = _TimezoneOffset___get_timeZone__impl__6q3m9h(dd.l10_1);
          break;
        case 'd':
        case 'dd':
          tmp_0 = padded(_DateTime___get_dayOfMonth__impl__z5062(utc), nlen);
          break;
        case 'do':
          tmp_0 = this.i12().z10(_DateTime___get_dayOfMonth__impl__z5062(utc));
          break;
        case 'M':
        case 'MM':
          tmp_0 = padded(_DateTime___get_month1__impl__hf8ase(utc), nlen);
          break;
        case 'MMM':
          tmp_0 = substr(Companion_getInstance_7().k(_DateTime___get_month1__impl__hf8ase(utc)).s10(this.i12()), 0, 3);
          break;
        case 'MMMM':
          tmp_0 = Companion_getInstance_7().k(_DateTime___get_month1__impl__hf8ase(utc)).s10(this.i12());
          break;
        case 'MMMMM':
          tmp_0 = substr(Companion_getInstance_7().k(_DateTime___get_month1__impl__hf8ase(utc)).s10(this.i12()), 0, 1);
          break;
        case 'y':
          tmp_0 = _DateTime___get_yearInt__impl__876eh3(utc);
          break;
        case 'yy':
          tmp_0 = padded(_DateTime___get_yearInt__impl__876eh3(utc) % 100 | 0, 2);
          break;
        case 'yyy':
          tmp_0 = padded(_DateTime___get_yearInt__impl__876eh3(utc) % 1000 | 0, 3);
          break;
        case 'yyyy':
          tmp_0 = padded(_DateTime___get_yearInt__impl__876eh3(utc), 4);
          break;
        case 'YYYY':
          tmp_0 = padded(_DateTime___get_yearInt__impl__876eh3(utc), 4);
          break;
        case 'H':
        case 'HH':
          tmp_0 = padded(mconvertRangeZero(_DateTime___get_hours__impl__gihczo(utc), 24), nlen);
          break;
        case 'k':
        case 'kk':
          tmp_0 = padded(mconvertRangeNonZero(_DateTime___get_hours__impl__gihczo(utc), 24), nlen);
          break;
        case 'h':
        case 'hh':
          tmp_0 = padded(mconvertRangeNonZero(_DateTime___get_hours__impl__gihczo(utc), 12), nlen);
          break;
        case 'K':
        case 'KK':
          tmp_0 = padded(mconvertRangeZero(_DateTime___get_hours__impl__gihczo(utc), 12), nlen);
          break;
        case 'm':
        case 'mm':
          tmp_0 = padded(_DateTime___get_minutes__impl__ua9590(utc), nlen);
          break;
        case 's':
        case 'ss':
          tmp_0 = padded(_DateTime___get_seconds__impl__145pqk(utc), nlen);
          break;
        case 'S':
        case 'SS':
        case 'SSS':
        case 'SSSS':
        case 'SSSSS':
        case 'SSSSSS':
        case 'SSSSSSS':
        case 'SSSSSSSS':
        case 'SSSSSSSSS':
          var milli = _DateTime___get_milliseconds__impl__xmznxd(utc);
          var tmp$ret$0;
          // Inline function 'kotlin.math.log10' call

          var tmp0_log10 = _DateTime___get_milliseconds__impl__xmznxd(utc);
          tmp$ret$0 = log10(tmp0_log10);
          var base10length = numberToInt(tmp$ret$0) + 1 | 0;
          var tmp_1;
          if (base10length > name.length) {
            var tmp_2 = milli;
            var tmp$ret$1;
            // Inline function 'kotlin.math.pow' call
            var tmp1_pow = imul(-1, base10length - name.length | 0);
            tmp$ret$1 = Math.pow(10.0, tmp1_pow);
            tmp_1 = numberToInt(tmp_2 * tmp$ret$1);
          } else {
            tmp_1 = substr(padded(milli, 3) + '000000', 0, name.length);
          }

          tmp_0 = tmp_1;
          break;
        case 'X':
        case 'XX':
        case 'XXX':
        case 'x':
        case 'xx':
        case 'xxx':
          var tmp_3;
          if (startsWith_0(name, 'X') ? _TimezoneOffset___get_totalMinutesInt__impl__9h3gzq(dd.l10_1) === 0 : false) {
            tmp_3 = 'Z';
          } else {
            var p = _TimezoneOffset___get_totalMinutesInt__impl__9h3gzq(dd.l10_1) >= 0 ? '+' : '-';
            // Inline function 'kotlin.math.absoluteValue' call
            var tmp2_get_absoluteValue_wf3xdr = _TimezoneOffset___get_totalMinutesInt__impl__9h3gzq(dd.l10_1) / 60 | 0;
            var hours = abs(tmp2_get_absoluteValue_wf3xdr);
            // Inline function 'kotlin.math.absoluteValue' call
            var tmp3_get_absoluteValue_igbyps = _TimezoneOffset___get_totalMinutesInt__impl__9h3gzq(dd.l10_1) % 60 | 0;
            var minutes = abs(tmp3_get_absoluteValue_igbyps);
            switch (name) {
              case 'X':
              case 'x':
                tmp_3 = p + padded(hours, 2);
                break;
              case 'XX':
              case 'xx':
                tmp_3 = p + padded(hours, 2) + padded(minutes, 2);
                break;
              case 'XXX':
              case 'xxx':
                tmp_3 = p + padded(hours, 2) + ':' + padded(minutes, 2);
                break;
              default:
                tmp_3 = name;
                break;
            }
          }

          tmp_0 = tmp_3;
          break;
        case 'a':
          tmp_0 = this.i12().a11().k(_DateTime___get_hours__impl__gihczo(utc) < 12 ? 0 : 1);
          break;
        default:
          var tmp_4;
          if (startsWith(name, _Char___init__impl__6a9atx(39))) {
            // Inline function 'kotlin.text.substring' call
            var tmp4_substring = name.length - 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            tmp_4 = name.substring(1, tmp4_substring);
          } else {
            tmp_4 = name;
          }

          tmp_0 = tmp_4;
          break;
      }
      out = tmp + toString(tmp_0);
    }
    return out;
  };
  protoOf(PatternDateFormat).toString = function () {
    return this.r11_1;
  };
  protoOf(PatternDateFormat).hashCode = function () {
    var result = getStringHashCode(this.r11_1);
    result = imul(result, 31) + (this.s11_1 == null ? 0 : hashCode(this.s11_1)) | 0;
    result = imul(result, 31) + this.t11_1.hashCode() | 0;
    result = imul(result, 31) + this.u11_1.hashCode() | 0;
    return result;
  };
  protoOf(PatternDateFormat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PatternDateFormat))
      return false;
    var tmp0_other_with_cast = other instanceof PatternDateFormat ? other : THROW_CCE();
    if (!(this.r11_1 === tmp0_other_with_cast.r11_1))
      return false;
    if (!equals(this.s11_1, tmp0_other_with_cast.s11_1))
      return false;
    if (!this.t11_1.equals(tmp0_other_with_cast.t11_1))
      return false;
    if (!this.u11_1.equals(tmp0_other_with_cast.u11_1))
      return false;
    return true;
  };
  function readRepeatedChar(_this__u8e3s4) {
    // Inline function 'korlibs.time.internal.MicroStrReader.readChunk' call
    var start = _this__u8e3s4.b12_1;
    // Inline function 'korlibs.time.readRepeatedChar.<anonymous>' call
    var c = _this__u8e3s4.e12();
    while (_this__u8e3s4.c12() ? _this__u8e3s4.d12(c) : false)
    ;
    var end = _this__u8e3s4.b12_1;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.a12_1.substring(start, end);
  }
  function mconvertRangeZero(value, size) {
    return umod(value, size);
  }
  function mconvertRangeNonZero(value, size) {
    var res = umod(value, size);
    return res === 0 ? size : res;
  }
  function PerformanceCounter() {
    PerformanceCounter_instance = this;
  }
  protoOf(PerformanceCounter).j12 = function () {
    return _HRTimeSpan___get_microsecondsDouble__impl__mglvkj(KlockInternal_getInstance().k12());
  };
  protoOf(PerformanceCounter).l12 = function () {
    return get_timeSpan(KlockInternal_getInstance().k12());
  };
  var PerformanceCounter_instance;
  function PerformanceCounter_getInstance() {
    if (PerformanceCounter_instance == null)
      new PerformanceCounter();
    return PerformanceCounter_instance;
  }
  function Companion_9() {
    Companion_instance_9 = this;
  }
  protoOf(Companion_9).yy = function () {
    return Companion_getInstance_1().yy();
  };
  var Companion_instance_9;
  function Companion_getInstance_10() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function TimeProvider() {
  }
  function _TimeSpan___init__impl__hqf6tm(milliseconds) {
    return milliseconds;
  }
  function _TimeSpan___get_milliseconds__impl__pb0we5($this) {
    return $this;
  }
  function _TimeSpan___get_nanoseconds__impl__gaf49o($this) {
    var tmp = _TimeSpan___get_milliseconds__impl__pb0we5($this);
    Companion_getInstance_11();
    return tmp / 1.0E-6;
  }
  function _TimeSpan___get_microseconds__impl__65sv9o($this) {
    var tmp = _TimeSpan___get_milliseconds__impl__pb0we5($this);
    Companion_getInstance_11();
    return tmp / 0.001;
  }
  function _TimeSpan___get_microsecondsInt__impl__sej7yz($this) {
    var tmp = _TimeSpan___get_milliseconds__impl__pb0we5($this);
    Companion_getInstance_11();
    return numberToInt(tmp / 0.001);
  }
  function _TimeSpan___get_seconds__impl__cx2k1c($this) {
    return _TimeSpan___get_milliseconds__impl__pb0we5($this) / get_MILLIS_PER_SECOND();
  }
  function _TimeSpan___get_millisecondsLong__impl__v1fxun($this) {
    return numberToLong(_TimeSpan___get_milliseconds__impl__pb0we5($this));
  }
  function TimeSpan__compareTo_impl_zidry4($this, other) {
    return compareTo(_TimeSpan___get_milliseconds__impl__pb0we5($this), _TimeSpan___get_milliseconds__impl__pb0we5(other));
  }
  function TimeSpan__compareTo_impl_zidry4_0($this, other) {
    var tmp = $this.m12_1;
    return TimeSpan__compareTo_impl_zidry4(tmp, other instanceof TimeSpan ? other.m12_1 : THROW_CCE());
  }
  function TimeSpan__unaryMinus_impl_24dqtx($this) {
    return _TimeSpan___init__impl__hqf6tm(-_TimeSpan___get_milliseconds__impl__pb0we5($this));
  }
  function TimeSpan__plus_impl_qdd6zo($this, other) {
    return _TimeSpan___init__impl__hqf6tm(_TimeSpan___get_milliseconds__impl__pb0we5($this) + _TimeSpan___get_milliseconds__impl__pb0we5(other));
  }
  function TimeSpan__minus_impl_5w5v8s($this, other) {
    return TimeSpan__plus_impl_qdd6zo($this, TimeSpan__unaryMinus_impl_24dqtx(other));
  }
  function TimeSpan__times_impl_86ofia($this, scale) {
    return _TimeSpan___init__impl__hqf6tm(_TimeSpan___get_milliseconds__impl__pb0we5($this) * scale);
  }
  function TimeSpan__times_impl_86ofia_0($this, scale) {
    return _TimeSpan___init__impl__hqf6tm(_TimeSpan___get_milliseconds__impl__pb0we5($this) * scale);
  }
  function TimeSpan__times_impl_86ofia_1($this, scale) {
    return _TimeSpan___init__impl__hqf6tm(_TimeSpan___get_milliseconds__impl__pb0we5($this) * scale);
  }
  function TimeSpan__div_impl_l42f2r($this, scale) {
    return _TimeSpan___init__impl__hqf6tm(_TimeSpan___get_milliseconds__impl__pb0we5($this) / scale);
  }
  function TimeSpan__div_impl_l42f2r_0($this, scale) {
    return _TimeSpan___init__impl__hqf6tm(_TimeSpan___get_milliseconds__impl__pb0we5($this) / scale);
  }
  function TimeSpan__div_impl_l42f2r_1($this, other) {
    return _TimeSpan___get_milliseconds__impl__pb0we5($this) / _TimeSpan___get_milliseconds__impl__pb0we5(other);
  }
  function TimeSpan__rem_impl_6i91m2($this, other) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp0_get_milliseconds_saqqmp = _TimeSpan___get_milliseconds__impl__pb0we5($this) % _TimeSpan___get_milliseconds__impl__pb0we5(other);
    return Companion_getInstance_11().g10(tmp0_get_milliseconds_saqqmp);
  }
  function _TimeSpan___get_isNil__impl__cma714($this) {
    return isNaN_0(_TimeSpan___get_milliseconds__impl__pb0we5($this));
  }
  function Companion_10() {
    Companion_instance_10 = this;
    this.ly_1 = new Long(1, 0);
    this.my_1 = 0.001;
    this.ny_1 = 1.0E-6;
    this.oy_1 = _TimeSpan___init__impl__hqf6tm(0.0);
    var tmp = this;
    DoubleCompanionObject_getInstance();
    tmp.py_1 = _TimeSpan___init__impl__hqf6tm(NaN);
    this.qy_1 = listOf([60, 60, 24]);
  }
  protoOf(Companion_10).g10 = function (ms) {
    return ms === 0.0 ? this.oy_1 : _TimeSpan___init__impl__hqf6tm(ms);
  };
  protoOf(Companion_10).n12 = function (s) {
    return this.g10(s * 1.0E-6);
  };
  protoOf(Companion_10).o12 = function (s) {
    return this.g10(s * 0.001);
  };
  protoOf(Companion_10).p12 = function (s) {
    return this.g10(s * get_MILLIS_PER_SECOND());
  };
  protoOf(Companion_10).ry = function (s) {
    return this.g10(s * get_MILLIS_PER_MINUTE());
  };
  protoOf(Companion_10).q12 = function (s) {
    return this.g10(s * get_MILLIS_PER_HOUR());
  };
  var Companion_instance_10;
  function Companion_getInstance_11() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function TimeSpan__toString_impl_2rdt8q($this) {
    return get_niceStr(_TimeSpan___get_milliseconds__impl__pb0we5($this)) + 'ms';
  }
  function TimeSpan__hashCode_impl_izs3k5($this) {
    return getNumberHashCode($this);
  }
  function TimeSpan__equals_impl_p77wuv($this, other) {
    if (!(other instanceof TimeSpan))
      return false;
    var tmp0_other_with_cast = other instanceof TimeSpan ? other.m12_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function TimeSpan(milliseconds) {
    Companion_getInstance_11();
    this.m12_1 = milliseconds;
  }
  protoOf(TimeSpan).r12 = function (other) {
    return TimeSpan__compareTo_impl_zidry4(this.m12_1, other);
  };
  protoOf(TimeSpan).t8 = function (other) {
    return TimeSpan__compareTo_impl_zidry4_0(this, other);
  };
  protoOf(TimeSpan).toString = function () {
    return TimeSpan__toString_impl_2rdt8q(this.m12_1);
  };
  protoOf(TimeSpan).hashCode = function () {
    return TimeSpan__hashCode_impl_izs3k5(this.m12_1);
  };
  protoOf(TimeSpan).equals = function (other) {
    return TimeSpan__equals_impl_p77wuv(this.m12_1, other);
  };
  function clamp(_this__u8e3s4, min, max) {
    return TimeSpan__compareTo_impl_zidry4(_this__u8e3s4, min) < 0 ? min : TimeSpan__compareTo_impl_zidry4(_this__u8e3s4, max) > 0 ? max : _this__u8e3s4;
  }
  function max(a, b) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.math.max' call
    var tmp0_max = _TimeSpan___get_milliseconds__impl__pb0we5(a);
    var tmp1_max = _TimeSpan___get_milliseconds__impl__pb0we5(b);
    var tmp2_get_milliseconds_9r3vfx = Math.max(tmp0_max, tmp1_max);
    return Companion_getInstance_11().g10(tmp2_get_milliseconds_9r3vfx);
  }
  function roundMilliseconds(_this__u8e3s4) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp0_get_milliseconds_saqqmp = round(_TimeSpan___get_milliseconds__impl__pb0we5(_this__u8e3s4));
    return Companion_getInstance_11().g10(tmp0_get_milliseconds_saqqmp);
  }
  function TimezoneNames_init_$Init$(tz, $this) {
    TimezoneNames.call($this, toMap(tz));
    return $this;
  }
  function TimezoneNames_init_$Create$(tz) {
    return TimezoneNames_init_$Init$(tz, objectCreate(protoOf(TimezoneNames)));
  }
  function Companion_11() {
    Companion_instance_11 = this;
    this.p11_1 = new Long(1, 0);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'korlibs.time.hours' call
    tmp$ret$0 = Companion_getInstance_11().q12(-7.0);
    var tmp_0 = to('PDT', new TimeSpan(tmp$ret$0));
    var tmp$ret$1;
    // Inline function 'korlibs.time.hours' call
    tmp$ret$1 = Companion_getInstance_11().q12(-8.0);
    var tmp_1 = to('PST', new TimeSpan(tmp$ret$1));
    var tmp$ret$2;
    // Inline function 'korlibs.time.hours' call
    tmp$ret$2 = Companion_getInstance_11().q12(0.0);
    var tmp_2 = to('GMT', new TimeSpan(tmp$ret$2));
    var tmp$ret$3;
    // Inline function 'korlibs.time.hours' call
    tmp$ret$3 = Companion_getInstance_11().q12(0.0);
    tmp.q11_1 = TimezoneNames_init_$Create$([tmp_0, tmp_1, tmp_2, to('UTC', new TimeSpan(tmp$ret$3))]);
  }
  var Companion_instance_11;
  function Companion_getInstance_12() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function TimezoneNames(namesToOffsets) {
    Companion_getInstance_12();
    this.s12_1 = namesToOffsets;
  }
  protoOf(TimezoneNames).toString = function () {
    return 'TimezoneNames(namesToOffsets=' + this.s12_1 + ')';
  };
  protoOf(TimezoneNames).hashCode = function () {
    return hashCode(this.s12_1);
  };
  protoOf(TimezoneNames).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimezoneNames))
      return false;
    var tmp0_other_with_cast = other instanceof TimezoneNames ? other : THROW_CCE();
    if (!equals(this.s12_1, tmp0_other_with_cast.s12_1))
      return false;
    return true;
  };
  function _TimezoneOffset___init__impl__4pq59n(totalMilliseconds) {
    return totalMilliseconds;
  }
  function _TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this) {
    return $this;
  }
  function _TimezoneOffset___get_positive__impl__x0f905($this) {
    return _TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this) >= 0.0;
  }
  function _TimezoneOffset___get_time__impl__u2t42f($this) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp0_get_milliseconds_saqqmp = _TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this);
    return Companion_getInstance_11().g10(tmp0_get_milliseconds_saqqmp);
  }
  function _TimezoneOffset___get_totalMinutes__impl__9kqntj($this) {
    return _TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this) / get_MILLIS_PER_MINUTE();
  }
  function _TimezoneOffset___get_totalMinutesInt__impl__9h3gzq($this) {
    return numberToInt(_TimezoneOffset___get_totalMinutes__impl__9kqntj($this));
  }
  function _TimezoneOffset___get_timeZone__impl__6q3m9h($this) {
    var sign = _TimezoneOffset___get_positive__impl__x0f905($this) ? '+' : '-';
    var hour = padded(_TimezoneOffset___get_deltaHoursAbs__impl__j5qorj($this), 2);
    var minute = padded(_TimezoneOffset___get_deltaMinutesAbs__impl__cjys5t($this), 2);
    var tmp;
    var tmp_0 = new TimeSpan(_TimezoneOffset___get_time__impl__u2t42f($this));
    var tmp$ret$0;
    // Inline function 'korlibs.time.minutes' call
    tmp$ret$0 = Companion_getInstance_11().ry(0.0);
    if (equals(tmp_0, new TimeSpan(tmp$ret$0))) {
      tmp = 'UTC';
    } else {
      tmp = 'GMT' + sign + hour + minute;
    }
    return tmp;
  }
  function _get_deltaTotalMinutesAbs__evvhpw($this) {
    return abs(numberToInt(_TimezoneOffset___get_totalMinutes__impl__9kqntj($this)));
  }
  function _TimezoneOffset___get_deltaHoursAbs__impl__j5qorj($this) {
    return _get_deltaTotalMinutesAbs__evvhpw($this) / 60 | 0;
  }
  function _TimezoneOffset___get_deltaMinutesAbs__impl__cjys5t($this) {
    return _get_deltaTotalMinutesAbs__evvhpw($this) % 60 | 0;
  }
  function TimezoneOffset__toString_impl_ibx4zv($this) {
    return _TimezoneOffset___get_timeZone__impl__6q3m9h($this);
  }
  function Companion_12() {
    Companion_instance_12 = this;
    this.t12_1 = _TimezoneOffset___init__impl__4pq59n(0.0);
    this.u12_1 = new Long(1, 0);
  }
  protoOf(Companion_12).v12 = function (time) {
    return _TimezoneOffset___init__impl__4pq59n(_TimeSpan___get_milliseconds__impl__pb0we5(time));
  };
  var Companion_instance_12;
  function Companion_getInstance_13() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function TimezoneOffset__compareTo_impl_kybaex($this, other) {
    return compareTo(_TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this), _TimezoneOffset___get_totalMilliseconds__impl__da1mf0(other));
  }
  function TimezoneOffset__compareTo_impl_kybaex_0($this, other) {
    var tmp = $this.w12_1;
    return TimezoneOffset__compareTo_impl_kybaex(tmp, other instanceof TimezoneOffset ? other.w12_1 : THROW_CCE());
  }
  function TimezoneOffset__hashCode_impl_uy106e($this) {
    return getNumberHashCode($this);
  }
  function TimezoneOffset__equals_impl_28rcam($this, other) {
    if (!(other instanceof TimezoneOffset))
      return false;
    var tmp0_other_with_cast = other instanceof TimezoneOffset ? other.w12_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function TimezoneOffset(totalMilliseconds) {
    Companion_getInstance_13();
    this.w12_1 = totalMilliseconds;
  }
  protoOf(TimezoneOffset).toString = function () {
    return TimezoneOffset__toString_impl_ibx4zv(this.w12_1);
  };
  protoOf(TimezoneOffset).x12 = function (other) {
    return TimezoneOffset__compareTo_impl_kybaex(this.w12_1, other);
  };
  protoOf(TimezoneOffset).t8 = function (other) {
    return TimezoneOffset__compareTo_impl_kybaex_0(this, other);
  };
  protoOf(TimezoneOffset).hashCode = function () {
    return TimezoneOffset__hashCode_impl_uy106e(this.w12_1);
  };
  protoOf(TimezoneOffset).equals = function (other) {
    return TimezoneOffset__equals_impl_28rcam(this.w12_1, other);
  };
  function get_offset(_this__u8e3s4) {
    return Companion_getInstance_13().v12(_this__u8e3s4);
  }
  function _Year___init__impl__2jvef0(year) {
    return year;
  }
  function _Year___get_year__impl__hjar94($this) {
    return $this;
  }
  function Companion_13() {
    Companion_instance_13 = this;
    this.pz_1 = new Long(1, 0);
    this.qz_1 = 365;
    this.rz_1 = 366;
    this.sz_1 = 1;
    this.tz_1 = 24;
    this.uz_1 = 97;
    this.vz_1 = 1461;
    this.wz_1 = 36524;
    this.xz_1 = 146097;
  }
  protoOf(Companion_13).y12 = function (year) {
    return (year % 4 | 0) === 0 ? !((year % 100 | 0) === 0) ? true : (year % 400 | 0) === 0 : false;
  };
  protoOf(Companion_13).yz = function (days) {
    var v400 = days / 146097 | 0;
    var r400 = days - imul(v400, 146097) | 0;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = r400 / 36524 | 0;
    var v100 = Math.min(tmp0_min, 3);
    var r100 = r400 - imul(v100, 36524) | 0;
    var v4 = r100 / 1461 | 0;
    var r4 = r100 - imul(v4, 1461) | 0;
    // Inline function 'kotlin.math.min' call
    var tmp1_min = r4 / 365 | 0;
    var v1 = Math.min(tmp1_min, 3);
    var extra = days < 0 ? 0 : 1;
    return _Year___init__impl__2jvef0((((extra + v1 | 0) + imul(v4, 4) | 0) + imul(v100, 100) | 0) + imul(v400, 400) | 0);
  };
  protoOf(Companion_13).h11 = function (isLeap) {
    return isLeap ? 366 : 365;
  };
  protoOf(Companion_13).z12 = function (year) {
    if (year < 1) {
      var leapCount = 0;
      var y = 1;
      while (y >= year) {
        if (_Year___get_isLeap__impl__kmyeoz(_Year___init__impl__2jvef0(y))) {
          leapCount = leapCount - 1 | 0;
        }
        y = y - 1 | 0;
      }
      return leapCount;
    }
    var y1 = year - 1 | 0;
    var res = ((y1 / 4 | 0) - (y1 / 100 | 0) | 0) + (y1 / 400 | 0) | 0;
    return res;
  };
  protoOf(Companion_13).a13 = function (year) {
    return imul(365, year - 1 | 0) + this.z12(year) | 0;
  };
  var Companion_instance_13;
  function Companion_getInstance_14() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function _Year___get_isLeap__impl__kmyeoz($this) {
    return Companion_getInstance_14().y12(_Year___get_year__impl__hjar94($this));
  }
  function _Year___get_days__impl__xyqg2q($this) {
    return Companion_getInstance_14().h11(_Year___get_isLeap__impl__kmyeoz($this));
  }
  function _Year___get_daysSinceOne__impl__cf4kem($this) {
    return Companion_getInstance_14().a13(_Year___get_year__impl__hjar94($this));
  }
  function Year__plus_impl_l5v1ey($this, delta) {
    return _Year___init__impl__2jvef0(_Year___get_year__impl__hjar94($this) + delta | 0);
  }
  function _HRTimeSpan___init__impl__12vyrk(nanosecondsRaw) {
    return nanosecondsRaw;
  }
  function _HRTimeSpan___get_nanosecondsRaw__impl__33lkpw($this) {
    return $this;
  }
  function Companion_14() {
    Companion_instance_14 = this;
    this.b13_1 = _HRTimeSpan___init__impl__12vyrk(0.0);
    var tmp = this;
    DoubleCompanionObject_getInstance();
    tmp.c13_1 = _HRTimeSpan___init__impl__12vyrk(NaN);
  }
  protoOf(Companion_14).d13 = function (value) {
    return _HRTimeSpan___init__impl__12vyrk(round(value * 1000000000));
  };
  protoOf(Companion_14).e13 = function (value) {
    return _HRTimeSpan___init__impl__12vyrk(round(value * 1000000));
  };
  protoOf(Companion_14).f13 = function (value) {
    return _HRTimeSpan___init__impl__12vyrk(round(value));
  };
  var Companion_instance_14;
  function Companion_getInstance_15() {
    if (Companion_instance_14 == null)
      new Companion_14();
    return Companion_instance_14;
  }
  function _HRTimeSpan___get_microsecondsDouble__impl__mglvkj($this) {
    return _HRTimeSpan___get_nanosecondsRaw__impl__33lkpw($this) / 1000;
  }
  function HRTimeSpan__plus_impl_q133f6($this, other) {
    return Companion_getInstance_15().f13(_HRTimeSpan___get_nanosecondsRaw__impl__33lkpw($this) + _HRTimeSpan___get_nanosecondsRaw__impl__33lkpw(other));
  }
  function get_timeSpan(_this__u8e3s4) {
    // Inline function 'korlibs.time.nanoseconds' call
    var tmp0_get_nanoseconds_e9619u = _HRTimeSpan___get_nanosecondsRaw__impl__33lkpw(_this__u8e3s4);
    return Companion_getInstance_11().n12(tmp0_get_nanoseconds_e9619u);
  }
  function increment(_this__u8e3s4, key) {
    // Inline function 'kotlin.collections.getOrPut' call
    var value = _this__u8e3s4.c2(key);
    var tmp;
    if (value == null) {
      // Inline function 'korlibs.time.internal.increment.<anonymous>' call
      var answer = 0;
      _this__u8e3s4.g4(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = ensureNotNull(_this__u8e3s4.c2(key)) + 1 | 0;
    _this__u8e3s4.g4(key, tmp0_set);
  }
  function MicroStrReader(str, offset) {
    offset = offset === VOID ? 0 : offset;
    this.a12_1 = str;
    this.b12_1 = offset;
  }
  protoOf(MicroStrReader).g13 = function () {
    return this.a12_1.length - this.b12_1 | 0;
  };
  protoOf(MicroStrReader).c12 = function () {
    return this.b12_1 < this.a12_1.length;
  };
  protoOf(MicroStrReader).h13 = function () {
    return !this.c12();
  };
  protoOf(MicroStrReader).f12 = function () {
    return charSequenceGet(this.a12_1, this.b12_1);
  };
  protoOf(MicroStrReader).e12 = function () {
    var tmp1 = this.b12_1;
    this.b12_1 = tmp1 + 1 | 0;
    return charSequenceGet(this.a12_1, tmp1);
  };
  protoOf(MicroStrReader).d12 = function (expected) {
    if (this.h13() ? true : !(this.f12() === expected))
      return false;
    this.e12();
    return true;
  };
  protoOf(MicroStrReader).g12 = function (expected) {
    return this.i13(expected) ? expected : null;
  };
  protoOf(MicroStrReader).i13 = function (expected) {
    if (expected.length > this.g13())
      return false;
    var inductionVariable = 0;
    var last = charSequenceLength(expected) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet(this.a12_1, this.b12_1 + n | 0) === charSequenceGet(expected, n)))
          return false;
      }
       while (inductionVariable <= last);
    this.b12_1 = this.b12_1 + expected.length | 0;
    return true;
  };
  function get_niceStr(_this__u8e3s4) {
    var tmp;
    // Inline function 'kotlin.math.floor' call
    if (Math.floor(_this__u8e3s4) === _this__u8e3s4) {
      tmp = '' + numberToInt(_this__u8e3s4);
    } else {
      tmp = '' + _this__u8e3s4;
    }
    return tmp;
  }
  function substr(_this__u8e3s4, start, length) {
    length = length === VOID ? _this__u8e3s4.length : length;
    var low = clamp_0(start >= 0 ? start : _this__u8e3s4.length + start | 0, 0, _this__u8e3s4.length);
    var high = clamp_0(length >= 0 ? low + length | 0 : _this__u8e3s4.length + length | 0, 0, _this__u8e3s4.length);
    var tmp;
    if (high < low) {
      tmp = '';
    } else {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.substring(low, high);
    }
    return tmp;
  }
  function padded(_this__u8e3s4, count) {
    var tmp$ret$0;
    // Inline function 'kotlin.math.absoluteValue' call
    tmp$ret$0 = abs(_this__u8e3s4);
    var res = padStart(tmp$ret$0.toString(), count, _Char___init__impl__6a9atx(48));
    var tmp;
    if (_this__u8e3s4 < 0) {
      return '-' + res;
    } else {
      tmp = res;
    }
    return tmp;
  }
  function umod(_this__u8e3s4, that) {
    var remainder = _this__u8e3s4 % that | 0;
    return remainder < 0 ? remainder + that | 0 : remainder;
  }
  function get_MILLIS_PER_SECOND() {
    return MILLIS_PER_SECOND;
  }
  var MILLIS_PER_SECOND;
  function get_MILLIS_PER_MINUTE() {
    return MILLIS_PER_MINUTE;
  }
  var MILLIS_PER_MINUTE;
  function get_MILLIS_PER_HOUR() {
    return MILLIS_PER_HOUR;
  }
  var MILLIS_PER_HOUR;
  function get_MILLIS_PER_DAY() {
    return MILLIS_PER_DAY;
  }
  var MILLIS_PER_DAY;
  function umod_0(_this__u8e3s4, that) {
    var remainder = _this__u8e3s4 % that;
    return remainder < 0.0 ? remainder + that : remainder;
  }
  function clamp_0(_this__u8e3s4, min, max) {
    return _this__u8e3s4 < min ? min : _this__u8e3s4 > max ? max : _this__u8e3s4;
  }
  function toInt2(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 < 0.0) {
      var tmp$ret$0;
      // Inline function 'kotlin.math.floor' call
      tmp$ret$0 = Math.floor(_this__u8e3s4);
      tmp = numberToInt(tmp$ret$0);
    } else {
      tmp = numberToInt(_this__u8e3s4);
    }
    return tmp;
  }
  function toIntMod(_this__u8e3s4, mod) {
    return toInt2(umod_0(_this__u8e3s4, mod));
  }
  var ExtendedTimezoneNamesOrNull;
  function get_isNode() {
    _init_properties_KlockInternal_kt__golekf();
    return isNode;
  }
  var isNode;
  function get_initialHrTime() {
    _init_properties_KlockInternal_kt__golekf();
    // Inline function 'kotlin.getValue' call
    initialHrTime$factory();
    return initialHrTime$delegate.q();
  }
  var initialHrTime$delegate;
  function KlockInternal() {
    KlockInternal_instance = this;
  }
  protoOf(KlockInternal).zy = function () {
    // Inline function 'kotlin.js.unsafeCast' call
    return Date.now();
  };
  protoOf(KlockInternal).k12 = function () {
    var tmp;
    if (get_isNode()) {
      // Inline function 'kotlin.js.unsafeCast' call
      var result = process.hrtime(get_initialHrTime());
      tmp = HRTimeSpan__plus_impl_q133f6(Companion_getInstance_15().d13(result[0]), Companion_getInstance_15().f13(result[1]));
    } else {
      tmp = Companion_getInstance_15().e13(window.performance.now());
    }
    return tmp;
  };
  var KlockInternal_instance;
  function KlockInternal_getInstance() {
    if (KlockInternal_instance == null)
      new KlockInternal();
    return KlockInternal_instance;
  }
  function initialHrTime$delegate$lambda() {
    _init_properties_KlockInternal_kt__golekf();
    return process.hrtime();
  }
  function initialHrTime$factory() {
    return getPropertyCallableRef('initialHrTime', 0, KProperty0, function () {
      return get_initialHrTime();
    }, null);
  }
  var properties_initialized_KlockInternal_kt_cyz5dp;
  function _init_properties_KlockInternal_kt__golekf() {
    if (!properties_initialized_KlockInternal_kt_cyz5dp) {
      properties_initialized_KlockInternal_kt_cyz5dp = true;
      isNode = typeof window === 'undefined';
      initialHrTime$delegate = lazy(initialHrTime$delegate$lambda);
    }
  }
  //region block: init
  KlockLocale_default = null;
  MILLIS_PER_SECOND = 1000;
  MILLIS_PER_MINUTE = 60000;
  MILLIS_PER_HOUR = 3600000;
  MILLIS_PER_DAY = 86400000;
  ExtendedTimezoneNamesOrNull = null;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = DateTime__format_impl_6el5l1;
  _.$_$.b = DateTime__hashCode_impl_yf0bc9;
  _.$_$.c = DateTime__minus_impl_10njw8_0;
  _.$_$.d = DateTime__minus_impl_10njw8;
  _.$_$.e = _DateTime___get_unixMillisLong__impl__sdx9bd;
  _.$_$.f = _Frequency___get_hertz__impl__9m7k6x;
  _.$_$.g = TimeSpan__compareTo_impl_zidry4;
  _.$_$.h = TimeSpan__div_impl_l42f2r;
  _.$_$.i = TimeSpan__div_impl_l42f2r_0;
  _.$_$.j = TimeSpan__div_impl_l42f2r_1;
  _.$_$.k = TimeSpan__hashCode_impl_izs3k5;
  _.$_$.l = _TimeSpan___get_isNil__impl__cma714;
  _.$_$.m = _TimeSpan___get_microseconds__impl__65sv9o;
  _.$_$.n = _TimeSpan___get_microsecondsInt__impl__sej7yz;
  _.$_$.o = _TimeSpan___get_milliseconds__impl__pb0we5;
  _.$_$.p = _TimeSpan___get_millisecondsLong__impl__v1fxun;
  _.$_$.q = TimeSpan__minus_impl_5w5v8s;
  _.$_$.r = _TimeSpan___get_nanoseconds__impl__gaf49o;
  _.$_$.s = TimeSpan__plus_impl_qdd6zo;
  _.$_$.t = TimeSpan__rem_impl_6i91m2;
  _.$_$.u = _TimeSpan___get_seconds__impl__cx2k1c;
  _.$_$.v = TimeSpan__times_impl_86ofia;
  _.$_$.w = TimeSpan__times_impl_86ofia_0;
  _.$_$.x = TimeSpan__times_impl_86ofia_1;
  _.$_$.y = TimeSpan__unaryMinus_impl_24dqtx;
  _.$_$.z = Companion_getInstance_0;
  _.$_$.a1 = Companion_getInstance_1;
  _.$_$.b1 = PerformanceCounter_getInstance;
  _.$_$.c1 = Companion_getInstance_10;
  _.$_$.d1 = Companion_getInstance_11;
  _.$_$.e1 = DateTime;
  _.$_$.f1 = TimeProvider;
  _.$_$.g1 = TimeSpan;
  _.$_$.h1 = TimedResult;
  _.$_$.i1 = clamp;
  _.$_$.j1 = max;
  _.$_$.k1 = roundMilliseconds;
  _.$_$.l1 = toFrequency;
  //endregion
  return _;
}));
